<template>
	<v-dialog :fullscreen="isMobile" attach v-model="open" max-width="700px" scrollable>
		<v-card height="50vh;" v-if="getMembershipUpsellModalEvent">
			<!-- <v-card-title>
				<p class="rsvp-modal-title">{{getMembershipUpsellModalEvent.title}}</p>
			</v-card-title>
			<v-divider></v-divider> -->
			<v-card-text class="modal__card-text basic-modal-padding">
				<v-layout row wrap>
					<div style="width: 50%; display: inline-block" class="rsvp-modal-border pa-2">
						<div class="text-xs-center">
							<v-icon color="info">fa-exclamation</v-icon><v-icon color="info">fa-exclamation</v-icon><p class="rsvp-modal-sub-title ml-2 mr-2" style="display: inline-block;">Pro Member</p><v-icon color="info">fa-exclamation</v-icon><v-icon color="info">fa-exclamation</v-icon>
							<p class="rsvp-modal-sub-title">
								${{getMembershipUpsellModalEvent.price}}
							</p>
						</div>
						<div>
							<p class="rsvp-modal-content">Being a pro member is great, join now!</p>
						</div>
					</div>

					<div style="width: 50%; display: inline-block" class="pa-2">
						<div class="text-xs-center">
							<p class="rsvp-modal-sub-title">Non Member</p>
							<p class="rsvp-modal-sub-title-light">
								${{getMembershipUpsellModalEvent.price + 5}}
							</p>
						</div>
						<v-spacer>
						</v-spacer>
						<div>
							<p class="rsvp-modal-content">Don't spend too much on this event, become a member now</p>
						</div>
					</div>
				</v-layout>
				<!-- <div id="dropin-container" style="min-height: 100px; width: 100%" class="pa-2"></div> -->
				<!-- <payment-form
					wrapperClass="constrain"
					:collectCardHolderName="true"
					:enableDataCollector="true"
					:enablePayPal="true">
				</payment-form> -->
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-btn style="width:90%" class="btn-blue" @click="becomeMember()">Become Member</v-btn>
				<v-spacer>
				</v-spacer>
				<v-btn style="width:90%;" @click="payNow()">Pay now</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PaymentForm from '~/components/payment/PaymentForm'
import axios from 'axios'
import btDropin from 'braintree-web-drop-in'
import { segmentIdentify, segmentTrack } from '~/plugins/segment'

export default {
	data() {
		return {
			startingPremium: false
		}
	},
	methods: {
		...mapActions([
			'setUserProp',
			'setModalOpen',
			'setPaymentModalEvent',
			'setPaymentModalStatus'
		]),
		becomeMember() {
			this.setPaymentModalStatus(true)
			this.setModalOpen({ prop: 'paymentModal', value: true })
			this.setPaymentModalEvent(this.getMembershipUpsellModalEvent)
			this.setModalOpen({ prop: 'membershipUpsellModal', value: false })
		},
		payNow() {
			this.setPaymentModalStatus(false)
			this.setModalOpen({ prop: 'paymentModal', value: true })
			this.setPaymentModalEvent(this.getMembershipUpsellModalEvent)
			this.setModalOpen({ prop: 'membershipUpsellModal', value: false })
		}
	},
	computed: {
		...mapGetters([
			'getAllEvents',
			'getModalProp',
			'getMembershipUpsellModalEvent'
		]),
		open: {
			get() {
				return this.getModalProp('membershipUpsellModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'membershipUpsellModal', value: val })
			}
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	},
	components: {
		PaymentForm
	}
}
</script>
